var path = 'app/scripts/modules/core/src/application/config/applicationNotifications.directive.html';
var html = "<p>You can edit notification settings for this application</p>\n<notification-list notifications=\"vm.notifications\" level=\"application\" application=\"vm.application.name\"/>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/application/config/applicationNotifications.directive.html
// module id = 953
// module chunks = 0